import { CampaignTypes } from '../../../Codes'
import TimeTableReadOnly from '../TimeTableReadOnly'
import { toBit } from '../../../../components/TimeTable'
import PropTypes from 'prop-types'

const AdGroupAfter = ({ after, subType }) => (
  <>
    {after.status && (
      <tr>
        <th scope="row">상태</th>
        <td>
          <div className="inner_cell">{after.status}</div>
        </td>
      </tr>
    )}
    {after.placement && (
      <tr>
        <th scope="row">매체유형</th>
        <td>
          <div className="inner_cell">{after.placement}</div>
        </td>
      </tr>
    )}
    {after.device && (
      <tr>
        <th scope="row">디바이스</th>
        <td>
          <div className="inner_cell">{after.device}</div>
        </td>
      </tr>
    )}
    {after.keywordExtension && (
      <tr>
        <th scope="row">
          {subType === CampaignTypes.TALK_CHANNEL
            ? '분절 키워드'
            : '키워드확장'}
        </th>
        <td>
          <div className="inner_cell">{after.keywordExtension}</div>
        </td>
      </tr>
    )}
    {after.exceptionKeyword && (
      <tr>
        <th scope="row">
          {subType === CampaignTypes.TALK_CHANNEL
            ? '분절 키워드 제외 키워드'
            : '제외 키워드'}
        </th>
        <td>
          <div className="inner_cell">{after.exceptionKeyword}</div>
        </td>
      </tr>
    )}
    {after.talkChannelRecommendKeyword && (
      <tr>
        <th scope="row">광고 추천 키워드</th>
        <td>
          <div className="inner_cell">{after.talkChannelRecommendKeyword}</div>
        </td>
      </tr>
    )}
    {after.dailyBudget && (
      <tr>
        <th scope="row">일예산</th>
        <td>
          <div className="inner_cell">{after.dailyBudget}</div>
        </td>
      </tr>
    )}
    {after.deviceBiddingWeight && (
      <tr>
        <th scope="row">PC/모바일 입찰 가중치</th>
        <td>
          <div className="inner_cell">{after.deviceBiddingWeight}</div>
        </td>
      </tr>
    )}
    {after.keywordExtensionBiddingWeight && (
      <tr>
        <th scope="row">키워드확장 입찰 가중치</th>
        <td>
          <div className="inner_cell">
            {after.keywordExtensionBiddingWeight}
          </div>
        </td>
      </tr>
    )}
    {after.strContentMatchingMaxBiddingAmount && (
      <tr>
        <th scope="row">콘텐츠 매체 입찰가</th>
        <td>
          <div className="inner_cell">
            {after.strContentMatchingMaxBiddingAmount}
          </div>
        </td>
      </tr>
    )}
    {after.impressionDuration && (
      <tr>
        <th scope="row">집행기간</th>
        <td>
          <div className="inner_cell">{after.impressionDuration}</div>
        </td>
      </tr>
    )}
    {after.impressionWeeklySchedule && (
      <tr>
        <th scope="row">집행 요일/시간</th>
        <td>
          <div className="inner_cell" style={{ maxHeight: 'none' }}>
            <TimeTableReadOnly
              weeklySchedule={toBit(after.impressionWeeklySchedule)}
              size="medium"
            />
          </div>
        </td>
      </tr>
    )}
    {subType !== CampaignTypes.TALK_CHANNEL && after.strMaxBiddingAmount && (
      <tr>
        <th scope="row">기본입찰가</th>
        <td>
          <div className="inner_cell">{after.strMaxBiddingAmount}</div>
        </td>
      </tr>
    )}
  </>
)
export default AdGroupAfter
AdGroupAfter.propTypes = {
  after: PropTypes.shape({
    status: PropTypes.string,
    placement: PropTypes.string,
    device: PropTypes.string,
    keywordExtension: PropTypes.string,
    exceptionKeyword: PropTypes.string,
    talkChannelRecommendKeyword: PropTypes.string,
    dailyBudget: PropTypes.string,
    deviceBiddingWeight: PropTypes.string,
    keywordExtensionBiddingWeight: PropTypes.string,
    strContentMatchingMaxBiddingAmount: PropTypes.string,
    impressionDuration: PropTypes.string,
    impressionWeeklySchedule: PropTypes.string,
    strMaxBiddingAmount: PropTypes.string,
  }),
  subType: PropTypes.string,
}
